var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"overflow-hidden",attrs:{"id":"archievments"}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('skills'),_c('awards')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }